import React, { useState } from "react";
import "./getdata.css";
import DatePicker from "react-datepicker";
import { OverlayTrigger, Tooltip, Modal, Button } from "react-bootstrap";
import lmp from "../assets/lmpdate.jpg";
import due from "../assets/duedates.jpg";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import back from "../assets/left.png";
function GetData() {
  const today = new Date();
  const [formData, setFormData] = useState({
    name: " ",
    age: "",
    height: "",
    weight: "",
  });
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedLmpDate, setSelectedLmpDate] = useState(null);
  const [selectedOption, setSelectedOption] = useState("dueDate");
  const [isCalculated, setIsCalculated] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);
  const [currentForm, setCurrentForm] = useState(1);
  const [weekNo, setWeekNo] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleNavigate = () => {
    setCurrentForm(1);
  };

  const handleLmpSelection = () => {
    setSelectedOption("lmpDate");
    setSelectedDate(null);
    setSelectedLmpDate(null);
  };

  const handleCalculate = () => {
    if (selectedOption === "dueDate" && !selectedDate) {
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 2000);
      return;
    }
    if (selectedOption === "lmpDate" && !selectedLmpDate) {
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 2000);
      return;
    }

    let weeks = 0;
    let days = 0;

    if (selectedOption === "dueDate" && selectedDate) {
      const diffTime = selectedDate - today;
      const diffDays = Math.floor(diffTime / (1000 * 3600 * 24));
      weeks = Math.floor(diffDays / 7);
      days = diffDays % 7;

      if (weeks > 40) {
        weeks = 40;
        days = 0;
      } else if (weeks < 0) {
        weeks = 0;
        days = 0;
      }
    } else if (selectedOption === "lmpDate" && selectedLmpDate) {
      const totalDays = calculateCurrentWeek(selectedLmpDate) * 7;
      weeks = Math.floor(totalDays / 7);
      days = totalDays % 7;
    }

    const weekString = `${weeks} week${weeks !== 1 ? "s" : ""} ${days} day${
      days !== 1 ? "s" : ""
    }`;
    setWeekNo(weekString);

    localStorage.setItem("weekNumber", weekString);
    console.log(`${weeks} weeks ${days} days`);

    setIsCalculated(true);
    setShowModal(true);
    // window.location.reload()
  };

  const calculateCurrentWeek = (selectDate) => {
    const currentDate = new Date();
    const diffTime = currentDate - selectDate;
    const diffDays = diffTime / (1000 * 3600 * 24);
    const weeks = Math.floor(diffDays / 7);

    return weeks > 40 ? 40 : weeks < 0 ? 0 : weeks;
  };

  const handleDueDateSelection = () => {
    setSelectedOption("dueDate");
    setSelectedLmpDate(null);
    setSelectedDate(null);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    localStorage.setItem("momInfo", JSON.stringify(formData));

    setFormData({ name: "", age: "", height: "", weight: "" });
    setWeekNo(null);
    setCurrentForm(currentForm + 1);
  };

  // function convertDaysToWeeksAndDays(totalDays) {
  //   let weeks = Math.floor(totalDays / 7);
  //   let days = totalDays % 7;
  //   return;
  // }

  return (
    <div id="main-getinfo-mom">
      <div className="form-container-getdata">
        <div className={`form-slide ${currentForm === 1 ? "active" : ""}`}>
          <form onSubmit={handleSubmit}>
            <h1 style={{ textTransform: "initial" }}>Mom Info</h1>
            <div className="form-group">
              <label htmlFor="name">Name*</label>
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="age">Age</label>
              <input
                type="number"
                id="age"
                name="age"
                value={formData.age}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="height">Height (in Cm)</label>
              <input
                type="number"
                id="height"
                name="height"
                value={formData.height}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label htmlFor="weight">Weight (in Kg)</label>
              <input
                type="number"
                id="weight"
                name="weight"
                value={formData.weight}
                onChange={handleChange}
              />
            </div>

            <button type="submit" className="button-get">
              Continue
            </button>
          </form>
        </div>

        <div className={`form-slide ${currentForm === 2 ? "active" : ""}`}>
          <form>
            <img
              onClick={handleNavigate}
              src={back}
              alt="left-back"
              style={{ width: "30px", marginBottom: "20px", cursor: "pointer" }}
            />
            <h2 className="text-cent" style={{ color: "black" }}>
              Choose a way to predict your due date
            </h2>

            <div className="image-options">
              <div
                className={`image-option ${
                  selectedOption === "dueDate" ? "selected" : ""
                }`}
                onClick={handleDueDateSelection}
              >
                <img src={due} alt="Due Date" />
                {/* <h4>Last Mensural Period</h4> */}
                {selectedOption === "dueDate" && (
                  <span className="tick-mark">✔</span>
                )}
                <p
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    color: "black",
                  }}
                >
                  I Know My Due Date
                </p>
              </div>

              <div
                className={`image-option ${
                  selectedOption === "lmpDate" ? "selected" : ""
                }`}
                onClick={handleLmpSelection}
              >
                <img src={lmp} alt="LMP Date" />
                {/* <h4>I know My Due Date</h4> */}
                {selectedOption === "lmpDate" && (
                  <span className="tick-mark" style={{ color: "white" }}>
                    ✔
                  </span>
                )}
                <p
                  style={{
                    textAlign: "center",
                    marginTop: "10px",
                    color: "black",
                  }}
                >
                  Last Mensural Period Date
                </p>
              </div>
            </div>

            <div className="date-picker-container">
              {selectedOption === "dueDate" && (
                <div className="select-due-date">
                  <label className="select-label">Select Due Date:</label>
                  <DatePicker
                    selected={selectedDate}
                    onChange={(date) => setSelectedDate(date)}
                    dateFormat="dd-MM-yyyy"
                    className="form-control"
                    placeholderText="Select Due Date"
                    minDate={today}
                    maxDate={
                      new Date(
                        today.getFullYear(),
                        today.getMonth() + 10,
                        today.getDate()
                      )
                    }
                    onKeyDown={(e) => e.preventDefault()}
                  />
                </div>
              )}

              {selectedOption === "lmpDate" && (
                <div className="select-lmp-date">
                  <label className="select-label">Select LMP Date:</label>
                  <DatePicker
                    selected={selectedLmpDate}
                    onChange={(date) => setSelectedLmpDate(date)}
                    dateFormat="dd-MM-yyyy"
                    className="form-control"
                    placeholderText="Select LMP Date"
                    minDate={
                      new Date(
                        today.getFullYear(),
                        today.getMonth() - 9,
                        today.getDate()
                      )
                    }
                    maxDate={today}
                    onKeyDown={(e) => e.preventDefault()}
                  />
                </div>
              )}
            </div>
            <div className="justify-center">
              <OverlayTrigger
                placement="top"
                overlay={
                  showTooltip ? (
                    <Tooltip id="tooltip">Please select a date</Tooltip>
                  ) : (
                    <></>
                  )
                }
              >
                <button
                  style={{ backgroundColor: "#B24C76" }}
                  className="calculate-buttons"
                  onClick={handleCalculate}
                  type="button"
                >
                  Submit
                </button>
              </OverlayTrigger>
            </div>
          </form>
          {/* Popup Modal */}
          <Modal
            show={showModal}
            onHide={() => setShowModal(false)}
            centered
            className="custom-modal"
          >
            <Modal.Header closeButton>
              <DotLottieReact
                src="https://lottie.host/ecd75ad1-0920-433d-bbf1-1f3045f5b2ae/8ttu0BndHp.lottie"
                loop
                autoplay
                style={{ width: "100%" }}
              />
            </Modal.Header>
            <Modal.Body>
              <Modal.Title>Congratulations</Modal.Title>
              <h2>{weekNo}</h2>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="secondary" onClick={() => setShowModal(false)}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </div>
      </div>
    </div>
  );
}

export default GetData;
